<template>
  <p-modal :visible="true" class="inspect-modal">
    <template #title>
      Inspect run
    </template>
    <template #footer>
      <p-button color="secondary" @click="$emit('close')">Close</p-button>
    </template>
    <div class="inspect-modal-body">
      <h3>
        {{ message }}
      </h3>
    </div>
  </p-modal>
</template>

<script>
import Button from '@/components/common/Button';
import Modal from '@/components/common/Modal';

export default {
  components: {
    'p-button': Button,
    'p-modal': Modal
  },
  props: {
    message: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.inspect-modal {
  .inspect-modal-body {
    padding: 1.75rem 2rem 0.75rem 2rem;
    h3 {
      font-size: 1rem;

      color: var(--theme-on-background);
      margin-bottom: 1rem;
    }
  }
}
</style>
